export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-button-group/index.js